export const vendorCentralStatusList = [
    { value: "Charged", label: "Charged" },
    { value: "Pending invoice", label: "Pending invoice" },
    { value: "Under review", label: "Under review" },
    { value: "Reversed", label: "Reversed" },
    { value: "Dispute under review", label: "Dispute under review" },
    { value: "Dispute approved", label: "Dispute approved" },
    { value: "Dispute rejected", label: "Dispute rejected" },
    { value: "Dispute - Needs more information", label: "Dispute - Needs more information" },
    { value: "Waived", label: "Waived" },
    { value: "Waived grace period", label: "Waived grace period" },
    { value: "Defect", label: "Defect" },
];